import { ApolloError, gql } from 'apollo-boost';
import c from 'classnames';
import { showSnackbar } from 'core/components/snackbar';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { WithStyles } from 'core/style/interfaces';
import { getErrors } from 'core/utils/apollo';
import React from 'react';
import { useAuth } from 'site/components/auth/AuthProvider';
import { useDisableSubscriptionAutopaymentMutation } from 'site/graphql';

gql`
    mutation DisableSubscriptionAutopayment {
        disableSubscriptionAutopayment
    }
`;
type IUnsubscribeButtonProps = {
    className?: string;
} & WithStyles<typeof styles>;

const UnsubscribeButton: React.FC<IUnsubscribeButtonProps> = ({ className, classes }) => {
    const { refetch } = useAuth();

    const [unsubscribe] = useDisableSubscriptionAutopaymentMutation({
        onCompleted: data => {
            if (data.disableSubscriptionAutopayment) {
                showSnackbar({ snackbarMessage: 'Автоплатеж успешно отменен' });
                refetch();
            }
        },
        onError: (error: ApolloError) => showSnackbar({ snackbarErrors: getErrors(error) }),
    });

    return (
        <button onClick={() => unsubscribe()} className={c(classes.button, className)}>
            Отменить
        </button>
    );
};

const styles = createStyles({
    button: {
        fontWeight: 'bold',
        fontSize: 16,
        border: '1px solid #cccccc',
        cursor: 'pointer',
        background: 'transparent',
        padding: 15,
        lineHeight: 1,

        '&:hover': {
            background: '#eee',
        },
    },
});

export default injectSheet(styles)(UnsubscribeButton);
